import { RowCrudStatus } from "../../common/types";
import { EsignatureDocument } from "../../../api/graphql";
import { LangStore } from "../../../store";
import { EsignatureDocumentStatus } from "../../../api/graphql";
import { FileCRUDType, fileCRUDInit } from "../../common/types";
import { formatBytes } from "../../../common/utils";

let uniqueCounter = 1;
export type EsignatureDocumentValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  status: EsignatureDocumentStatus;
  sentAt: Date | null;
  completedAt: Date | null;
  signedDocument: string;
  signedDocument_data: FileCRUDType;
  __signedDocument_files: FileCRUDType[];
  sourceEntityType: string;
  sourceEntityId: string;
};

export type EsignatureDocumentErrorsType = {
  status?: { message: string; fieldLabel: string };
  sentAt?: { message: string; fieldLabel: string };
  completedAt?: { message: string; fieldLabel: string };
  signedDocument?: { message: string; fieldLabel: string };
  sourceEntityType?: { message: string; fieldLabel: string };
  sourceEntityId?: { message: string; fieldLabel: string };
};

export function EsignatureDocumentValuesInit(): EsignatureDocumentValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    status: "draft" as EsignatureDocumentStatus,
    sentAt: null,
    completedAt: null,
    signedDocument: "",
    signedDocument_data: fileCRUDInit(),
    __signedDocument_files: [],
    sourceEntityType: "",
    sourceEntityId: "",
  };
}

export type EsignatureDocumentType =
  | EsignatureDocument
  | EsignatureDocumentValuesType;

export function esignatureDocumentDisplayId(
  source: Partial<EsignatureDocument>,
  _langStore: LangStore
) {
  return source.name ?? _langStore.emptyStringSymbol;
}

export function getEsignatureDocumentValues(
  source: EsignatureDocumentType,
  _langStore: LangStore,
  _duplicated: boolean = false
): EsignatureDocumentValuesType {
  const entityValues = EsignatureDocumentValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : esignatureDocumentDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.status = source.status;
  entityValues.sentAt = source.sentAt ? new Date(source.sentAt) : null;
  entityValues.completedAt = source.completedAt
    ? new Date(source.completedAt)
    : null;
  entityValues.__signedDocument_files =
    source.signedDocument_data && !_duplicated
      ? [
          {
            id:
              "id" in source.signedDocument_data &&
              source.signedDocument_data.id
                ? source.signedDocument_data.id
                : `generated_${uniqueCounter++}`,
            name: source.signedDocument_data.name,
            description: source.signedDocument_data.description || undefined,
            size: source.signedDocument_data.size || 0,
            formattedSize: source.signedDocument_data.size
              ? formatBytes(source.signedDocument_data.size)
              : "",
            mimetype: source.signedDocument_data.mimetype,
            url: source.signedDocument_data.url || undefined,
            __status__: "original",
          },
        ]
      : [];
  entityValues.signedDocument =
    source.signedDocument && !_duplicated ? source.signedDocument : "";
  entityValues.signedDocument_data =
    source.signedDocument_data && "__status__" in source.signedDocument_data
      ? source.signedDocument_data
      : source.signedDocument_data
      ? {
          id: ("id" in source.signedDocument_data &&
          source.signedDocument_data.id
            ? source.signedDocument_data.id
            : `generated_${uniqueCounter++}`) as string,
          name: source.signedDocument_data.name,
          description: source.signedDocument_data.description || undefined,
          size: source.signedDocument_data.size || 0,
          formattedSize: source.signedDocument_data.size
            ? formatBytes(source.signedDocument_data.size)
            : "",
          mimetype: source.signedDocument_data.mimetype,
          url: source.signedDocument_data.url || undefined,
          __status__: "original" as RowCrudStatus,
        }
      : fileCRUDInit();
  entityValues.sourceEntityType = source.sourceEntityType || "";
  entityValues.sourceEntityId = source.sourceEntityId || "";
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}
